export class Geolocation {
  set(latitude, longitude) {
    // setGeolocation()
    const $lat = $('#edit-lat');
    const $lng = $('#edit-lng');

    $lat.val(latitude);
    $lng.val(longitude);
  }

  get($element) {
    // geolocate()
    $element.parents('form').find('.btn').prop('disabled', true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.set(position.coords.latitude, position.coords.longitude);
        $element.parents('form').submit();
      },
      () => {
        $element.val('');
        $element.parents('form').find('.btn').prop('disabled', false);
        alert(
          "Error detecting your location. We couldn't detect your location."
        );
      },
      {
        timeout: 5000,
      }
    );
  }
}

export class ProximityAutocomplete {
  constructor(context) {
    this.context = context;
  }

  init() {
    let $ac = $('.proximity-autocomplete', this.context);

    if (!$ac.length) {
      return;
    }

    // If the sort changes to anything other than 'distance', blank the proximity field.
    let $sort = $('#edit-sort');
    $sort.change(function () {
      if ($sort.val() !== 'distance') {
        $ac.val('');
      }
    });

    let current_loc_option = Drupal.t('Use my current location');
    let current_loc = Drupal.t('Current Location');

    const geolocation = new Geolocation();

    $ac
      .autocomplete({
        delay: 0,
        minLength: 0,
        select: (event, ui) => {
          let selected = ui.item.value;
          selected = selected.replace(current_loc_option, current_loc);
          $(event.target).val(selected);
          if (selected === current_loc) {
            geolocation.get($(event.target));
          } else {
            // Clear lat/lng.
            geolocation.set('', '');
            $(this).parents('form').submit();
          }
          return false;
        },
        source: (request, response) => {
          if (request.term === '') {
            let results = [];
            results.push(current_loc_option);
            response(results);
          } else {
            $.ajax({
              url:
                'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
                request.term +
                '.json',
              data: {
                access_token: drupalSettings.mapboxgl.accessToken,
                autocomplete: true,
                country: 'us',
                types: 'place',
                limit: 5,
                language: 'en',
                // Restrict search results to the area around known locations.
                bbox: '-89.98156,40.42503,-85.8507,43.40807',
              },
              dataType: 'json',
              success: function (data) {
                let results = [];
                $.each(data.features, function (index, value) {
                  let city = value.context[0].short_code.replace('US-', '');
                  let place = value.text + ', ' + city;
                  results.push(place);
                });
                response(results);
              },
              error: function () {
                response({});
              },
            });
          }
        },
      })
      .on('focus', function () {
        if ($(this).val() === '') {
          $(this).autocomplete('search', '');
        }
      });
  }
}

export class KeywordAutoComplete {
  constructor(context) {
    this.context = context;
  }

  init() {
    if (typeof drupalSettings.locationsSearchForm != 'undefined') {
      let settings = drupalSettings.locationsSearchForm;

      let $search = jQuery('input.keyword-search', this.context);
      if ($search.length) {
        new autoComplete({
          selector: $search.get(0),
          source: function (term, response) {
            jQuery.getJSON(
              settings.suggest,
              {
                q: term,
              },
              function (data) {
                response(data);
              }
            );
          },
          onSelect: function (e, term, item) {
            // When a suggestion is selected, submit the form.
            $search.val(term);
            $search.closest('form').submit();
          },
        });
      }
    }
  }
}

export class Map {
  constructor(context) {
    this.context = context;
  }

  init() {
    if (
      typeof drupalSettings.locationsMap !== 'undefined' &&
      typeof drupalSettings.locationsMap.data !== 'undefined' &&
      $('#locations-map', this.context).length
    ) {
      mapboxgl.accessToken = drupalSettings.mapboxgl.accessToken;
      var map = new mapboxgl.Map({
        container: 'locations-map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-87.668, 41.875],
        zoom: 12,
        scrollZoom: false,
      });
      map.addControl(new mapboxgl.NavigationControl());

      var bounds = new mapboxgl.LngLatBounds();
      var map_data = drupalSettings.locationsMap.data;
      let markerArr = [];
      let activeMarker;

      $.each(map_data, function (index, location) {
        // Popup / Infowindow.
        var popup = new mapboxgl.Popup({
          offset: 25,
          maxWidth: '340px',
        }).setHTML(location.content);

        // Marker.
        let marker = document.createElement('div');
        marker.className = 'marker';

        let markerObj = new mapboxgl.Marker(marker, {
          color: '#254380',
        })
          .setLngLat(location.geolocation)
          .setPopup(popup)
          .addTo(map);

        markerArr.push(markerObj);

        bounds.extend(location.geolocation);

        marker.addEventListener('click', (e) => {
          // Remove active class and close markers' popup which are not our e.target.
          let markers = Array.from(marker.parentNode.children);
          markers = markers.filter((marker) =>
            marker.classList.contains('marker')
          );

          markers.forEach((el, i) => {
            if (el.classList.contains('active') && el[index] !== index) {
              document
                .querySelector('.mapboxgl-interactive')
                .querySelectorAll('.marker')
                .item(i)
                .classList.remove('active');
              markerArr[i]._popup.remove();
            }
          });

          // Toggle active class on marker.
          /* istanbul ignore if - This is always false */
          if (e.target.classList.contains('active')) {
            e.target.classList.remove('active');
          } else {
            e.target.classList.add('active');
            activeMarker = e.target;
          }
        });

        // Remove active class on marker when close button is clicked.
        popup.on('close', (e, i) => {
          activeMarker.classList.remove('active');
        });

        popup.on('open', (e, i) => {
          let popupSlider = '.mapboxgl-popup--location-slider';
          let totalCount = $(
            `${popupSlider} .mapboxgl-popup--location-slider--wrap`
          ).length;

          if (totalCount > 1) {
            // Set 1 of x text.
            $(`.mapboxgl-popup--location-count .total`).text(
              ` of ${totalCount}`
            );

            let currentSlide = $('.mapboxgl-popup--location-count .current');
            currentSlide.text('1');

            $(popupSlider).slick({
              appendArrows: $('.mapboxgl-popup--location-count'),
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            });

            $(popupSlider).on('afterChange', (e, slick) => {
              // Update x of x text.
              let currentSlideNumber = $(`${popupSlider} .slick-active`).attr(
                'data-slick-index'
              );
              currentSlideNumber = parseInt(currentSlideNumber) + 1;

              currentSlide.text(currentSlideNumber);
            });
          }
        });
      });

      if (!bounds.isEmpty()) {
        map.fitBounds(bounds, { padding: 100, maxZoom: 13 });
      }
    }
  }
}

export class FormBehaviors {
  constructor(context) {
    this.context = context;
  }

  dropdowns() {
    nakedFormSelect('select#edit-location-type', {
      context: {
        value: this.context,
      },
      keywordSearch: {
        on: true,
      },
      submitBtn: {
        on: true,
        text: 'Apply',
      },
    });

    nakedFormSelect('select#edit-specialty', {
      context: {
        value: this.context,
      },
      keywordSearch: {
        on: true,
      },
      submitBtn: {
        on: true,
        text: 'Apply',
      },
    });

    nakedFormSelect('select#edit-sort', {
      context: {
        value: this.context,
      },
    });
  }
  submit() {
    // Auto-submit the form when the map toggle, child toggle, or the sort is changed.
    $('.map-toggle, #edit-sort, #edit-pediatrics', this.context).change(
      function () {
        $(this).closest('form').submit();
      }
    );
  }
  init() {
    this.dropdowns();
    this.submit();
  }
}

export class LocationsLandingPage extends DrupalBehavior {
  onContent(context) {
    const map = new Map(context);
    const proximityAutocomplete = new ProximityAutocomplete(context);
    const keywordAutocomplete = new KeywordAutoComplete(context);
    const formBehaviors = new FormBehaviors(context);

    map.init();
    proximityAutocomplete.init();
    keywordAutocomplete.init();
    formBehaviors.init();
  }
}

DrupalBehavior.register(
  'rush_theme.pages',
  'rush_model_locations_landing',
  LocationsLandingPage
);
